import Immutable from 'immutable';
import * as JsSearch from 'js-search';
import localStorage from '../../lib/localStorage';

export const GET_LOCATIONS = 'takeback/api/GET_LOCATIONS';
export const GET_LOCATIONS_SUCCESS = 'takeback/api/GET_LOCATIONS_SUCCESS';
export const GET_LOCATIONS_FAILURE = 'takeback/api/GET_LOCATIONS_FAILURE';

export const SEARCH_LOCATIONS = 'takeback/locations/SEARCH';
export const RESET_FILTER = 'takeback/locations/RESET_FILTER';

export const FAVORITE_LOCATION = 'takeback/locations/FAVORITE';
export const UNFAVORITE_LOCATION = 'takeback/locations/UNFAVORITE';

export const CREATE_LOCATION_SUBMIT = 'takeback/locations/CREATE_LOCATION_SUBMIT';
export const CREATE_LOCATION_SUCCESS = 'takeback/locations/CREATE_LOCATION_SUCCESS';
export const CREATE_LOCATION_FAILURE = 'takeback/locations/CREATE_LOCATION_FAILURE';

export const UPDATE_LOCATION_SUBMIT = 'takeback/locations/UPDATE_LOCATION_SUBMIT';
export const UPDATE_LOCATION_SUCCESS = 'takeback/locations/UPDATE_LOCATION_SUCCESS';
export const UPDATE_LOCATION_FAILURE = 'takeback/locations/UPDATE_LOCATION_FAILURE';

export const HIDE_LOCATION_SUBMIT = 'takeback/locations/HIDE_LOCATION_SUBMIT';
export const HIDE_LOCATION_SUCCESS = 'takeback/locations/HIDE_LOCATION_SUCCESS';
export const HIDE_LOCATION_FAILURE = 'takeback/locations/HIDE_LOCATION_FAILURE';

const initialState = Immutable.Map({
    // A map of all locations, indexed by id
    list: Immutable.Map(),

    // A list of ids
    filtered: Immutable.Set(),

    // TODO: Is this the right place?
    favorites: Immutable.Set(localStorage.get('locations.favorites')),

    // The current filter
    filter: null,
});

const search = new JsSearch.Search('id');
search.indexStrategy = new JsSearch.AllSubstringsIndexStrategy();


search.tokenizer = {
    tokenize(text) {
        // This is needed to index umlauts and other non latin characters
        return text
            .split(/[^a-zA-Z\x7f-\xff0-9\-']+/)
            .filter(str => !!str);
    },
};

search.addIndex(['address', 'city']);
search.addIndex(['address', 'email']);
search.addIndex(['address', 'organization']);
search.addIndex(['address', 'street']);
search.addIndex(['address', 'unit']);
search.addIndex(['number']);
search.addIndex(['info']);
search.addIndex(['oldNumber']);

// Reducers
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case GET_LOCATIONS_SUCCESS: {
        search.addDocuments(action.locations.toList().toJS());
        return state.set('list', state.get('list').mergeDeep(action.locations.reduce((map, location) => {
            return map.set(location.get('id'), location);
        }, Immutable.Map())));
    }

    case RESET_FILTER: {
        return state
            .set('filter', null)
            .set('filtered', Immutable.Set());
    }

    case CREATE_LOCATION_SUCCESS: {
        const location = action.payload;
        search.addDocuments([location.toJS()]);
        return state.update('list', list => (
            list.set(location.get('id'), location)
        ));
    }

    case UPDATE_LOCATION_SUCCESS: {
        const location = action.payload;
        search.addDocuments([location.toJS()]);
        return state.update('list', list => (
            list.set(location.get('id'), location)
        ));
    }

    case SEARCH_LOCATIONS: {
        const results = search.search(action.term);
        return state
            .set('filter', action.term)
            .set('filtered', Immutable.Set(results.map(location => location.id)));
    }

    case FAVORITE_LOCATION: {
        // We only allow a single favorite location right now
        const result = state.update('favorites', list => list.clear().add(action.id));
        localStorage.set('locations.favorites', result.get('favorites').toJS());
        return result;
    }

    case UNFAVORITE_LOCATION: {
        // We only allow a single favorite location right now
        const result = state.update('favorites', list => list.clear());
        localStorage.set('locations.favorites', result.get('favorites').toJS());
        return result;
    }

    default: return state;
    }
}

// Selectors
export function selectLocations(state) {
    return state.locations.get('list');
}

export function selectLocationFilter(state) {
    return state.locations.get('filter');
}

export function selectFavorites(state) {
    return state.locations.get('favorites');
}

export function isFavorite(state, locationId) {
    return state.locations.get('favorites').contains(locationId);
}

export function selectFavoriteLocations(state) {
    return state.locations.get('favorites').map(id => (
        state.locations.get(['list', parseInt(id, 10)])
    ));
}

// TODO: Rewrite this as a proper reselect selector
export function selectFilteredLocations(state, returnAllOnEmptyFilter = true) {
    if (returnAllOnEmptyFilter && !state.locations.get('filter')) {
        return selectLocations(state);
    }
    return state.locations.get('filtered').reduce((result, id) => {
        return result.set(id, state.locations.getIn(['list', id]));
    }, Immutable.Map());
}

export function selectLocation(state, location) {
    return state.locations.getIn(['list', parseInt(location, 10)]);
}

// Actions
export function resetFilter() {
    return { type: RESET_FILTER };
}

export function favoriteLocation(id) {
    return { type: FAVORITE_LOCATION, id };
}

export function unfavoriteLocation(id) {
    return { type: UNFAVORITE_LOCATION, id };
}

export function searchLocations(term) {
    return { type: SEARCH_LOCATIONS, term };
}

export function getLocations(params = {}, options = {}) {
    return Object.assign({ type: GET_LOCATIONS, params }, options);
}

export function getLocationsSuccess(locations) {
    return { type: GET_LOCATIONS_SUCCESS, locations };
}

export function getLocationsFailure(error) {
    return { type: GET_LOCATIONS_FAILURE, error };
}

export function hideLocation(id) {
    return { type: HIDE_LOCATION_SUBMIT, id };
}

